__turbopack_context__.v({
  "className": "noto_sans_display_688d63e-module__vF5Vkq__className",
});
